const AppWithLoading = ({ children }) => {
  // No artificial loading - only real loading states (API calls, chart generation)
  return children;
};

export default AppWithLoading;
